import CollapsibleHeaderCallout from './CollapsibleHeaderCallout';

export default CollapsibleHeaderCallout;
